import React from "react";
import * as styles from "./StartingOverlay.module.scss";

type StartingOverlayProps = {
  show?: boolean;
  label?: string;
};

const StartingOverlay: React.FC<StartingOverlayProps> = ({ show = true, label = "Iniciando" }) => {
  if (!show) return null;

  return (
    <div className={styles.overlay} role="status" aria-live="polite">
      <div className={styles.content}>
        <span className={styles.text}>
          {label}
          <span className={styles.dots}></span>
        </span>
      </div>
    </div>
  );
};

export default StartingOverlay;
